import { render } from "./KeepAlive.vue?vue&type=template&id=4bd66594"
import script from "./KeepAlive.vue?vue&type=script&lang=js"
export * from "./KeepAlive.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__